<template>
	<v-layout row wrap>
		<v-flex xs4>
			<v-dialog v-on:update:return-value="saveChanges" v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
				<template v-slot:activator="{ on }">
					<v-btn :disabled="disabled" color="brown darken-2" dark v-on="on">
					    <v-icon medium>search</v-icon>&nbsp; Organization Search Tool</v-btn>
					<br /><br />
				</template>
				<v-card class="bg-light-blue">
					<v-toolbar dark class="brown darken-2">
						<v-btn class="icon primary ml-3" @click="dialog = false">
							<v-icon>mdi-arrow-left</v-icon>Back
						</v-btn>
						<v-toolbar-title class="ml-6">Organization Search Tool</v-toolbar-title>
						<v-spacer></v-spacer>
					</v-toolbar>
					<div border="0">
						<p style="padding-top: 0px; padding-bottom: 0px; margin-bottom: 0px;"><br/><b>
							You can only add a specific institution to the list one time. To add several institutions, it will probably save you time to stay on this page and add them all at once.
							<br />(1) Enter the organization name or code in the Search box.
							<br />(2) When the name appears in the table below, click on the plus sign.
							<br />(3) After you see the box saying the institution was added, start over at (1).</b>
						</p>
						<p><br/><b>When you return to the question page, you will probably have to click on “SAVE” then click “Home” and then return to the page before you see your institutions.</b></p>
					</div>
					<v-layout row wrap class="py-2">
						<v-flex xs1/>
						<v-flex xs10>
							<v-text-field
								id="search-field"
								v-model="value"
								label="Type an organization name or code"
								prepend-inner-icon="search"
								persistent-hint
								hint="Min 3 characters to start search"
								clearable>
							</v-text-field>
						</v-flex>
					</v-layout>

					<v-data-table
						:headers="headers"
						:items="organizationList"
						:loading="loading"
						loading-text="Loading... Please wait"
						class="elevation-1 mx-5"
					>
						<template v-slot:item.action="{ item }">
							<v-icon
								class="mr-2 green--text"
								@click="addClick(item)">
								mdi-plus-circle
							</v-icon>
						</template>
					</v-data-table>

					<p class="my-4 body-2">
						<v-icon medium>help</v-icon>&nbsp;If you cannot find an institution or organization code, contact survey support to add or assign the institution or organization code.
					</p>

					<v-snackbar
						v-model="snackbar"
						:top="true"
						:color="snackColor"
					>
						{{ snackMessage }}
						<v-btn
							dark
							text
							@click="closeSnack()"
						>

						</v-btn>
					</v-snackbar>
				</v-card>
			</v-dialog>
		</v-flex>

		<!-- <v-flex xs12>
			<hr />
    </v-flex> -->
	</v-layout>
</template>

<script>
import { lookUpService } from "../../services/lookUpService";
export default {
  name: "OrganizationSearchTool",
  props: {
		snackMessage: String,
		snackbarHolder: Boolean,
		snackColor: String,
		disabled: Boolean
  },
	data: () => ({
		dialogHolder: false,
    notifications: false,
    sound: true,
		widgets: false,
		value: null,
		loading: false,
		headers: [
		{ text: 'Add', align: 'start', sortable: false, value: 'action' },
        { text: 'Code', value: 'organizationFice' },
        { text: 'Name', value: 'organizationName' },
        { text: 'State', value: 'state' },,
        { text: 'City', value: 'city' },,
        { text: 'Type', value: 'organizationTypeCode' }
      ],
		organizationList: []
	}),
	methods: {
		addClick (item) {
			this.$emit('addClick', {
        code: item.organizationFice,
				name: item.organizationName,
				type: item.organizationTypeCode
      });
		},
		closeSnack () {
			this.$emit('closeSnack')
		},
		saveChanges () {
			debugger;
			this.$store.commit('setIsLoading', { isLoading: true });
			this.$emit('save');
		}
	},
	watch: {
		value: function (newVal, oldVal) {
			if (newVal && newVal.length > 2) {
				this.loading = true;
				var requestBody = {
					search: newVal
				}
				const me = this;

				lookUpService.searchOrganizations(requestBody).then(function (response) {
					if (response && response.data.results) {
						me.organizationList = response.data.results;
						me.loading = false;
					}
				})
				.catch(function (e) {
					console.log(e);
					throw e;
				});
			} else {
				this.organizationList = [];
			}
		}
	},
	computed: {
		dialog: {
			get: function () {
				return this.dialogHolder;
			},
			set: function (newVal) {
				var navTop = document.getElementById("survey-nav");

				if (newVal) {
					navTop.classList.add("fullscreen");
				} else {
					navTop.classList.remove("fullscreen");
				}
				this.dialogHolder = newVal;
			}
		},
		snackbar: {
			get: function () {
				return this.snackbarHolder;
			},
			set: function (newVal) {
				this.closeSnack();
			}
		}
	},
  mounted () {

	}
};
</script>

<style scoped>
.row-label {
	/*GBC line-height: 48px;*/
	font-weight: bold;
	text-align: left;
}
.row-label-sub {
	font-weight: normal;
	text-align: left;
	margin-top: 10px;
	margin-left: 5%;
}
.row-label-help {
	font-weight: normal;
	text-align: left;
	margin-left: 25px;
}

.bg-light-blue {
	background-color: #d9e2f3 !important; /* have to force it on this page but not globally so local to page */
}

.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn-outlined) {
  color: grey !important;
	background: #cfdbf1 !important;
}
</style>
